export default {"src":"/_next/static/media/security-loan.9297256c.svg","height":37,"width":34};